import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "microsoft-title" }
const _hoisted_3 = {
  class: "google-auth-download",
  href: "https://hongtaiyang.vip/files/Authenticator.apk"
}
const _hoisted_4 = { class: "google-notice" }
const _hoisted_5 = { class: "google-guide" }
const _hoisted_6 = {
  class: "google-auth",
  target: "_blank",
  href: "https://hongtaiyang.vip/files/%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E5%99%A8--GreenX%E8%B4%A6%E5%8F%B7%E5%A6%82%E4%BD%95%E8%AE%BE%E7%BD%AE%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E7%A0%81.pdf"
}

import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleAuthenticatorView',
  setup(__props) {

const { t } = useI18n();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_unref(t)('下载安卓版微软Authenticator')), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('微软Authenticator下载')), 1),
    _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('谷歌验证器下载')), 1),
    _createElementVNode("p", _hoisted_4, [
      _createTextVNode(_toDisplayString(_unref(t)('谷歌验证器可用于开启（账户安全）中的（谷歌验证码）')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('重要提示！！设置谷歌验证码时，请注意保存谷歌密钥，防止丢失不易找回！')), 1)
    ]),
    _createElementVNode("p", _hoisted_5, [
      _createTextVNode(_toDisplayString(_unref(t)('点击下载查看GreenX设置谷歌验证码指南')) + " ----", 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(t)('《谷歌验证器-GreenX账号如何设置谷歌验证码》')), 1)
    ])
  ]))
}
}

})